// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as InputSearch from "./InputSearch.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";

let make = React.memo(props => {
  let onChange = props.onChange;
  let __autoFocus = props.autoFocus;
  let __value = props.value;
  let value = __value !== undefined ? __value : "";
  let autoFocus = __autoFocus !== undefined ? __autoFocus : true;
  let mounted = React.useRef(false);
  let match = React.useState(() => false);
  let setFocused = match[1];
  let match$1 = React.useState(() => value);
  let setSearchQuery = match$1[1];
  let searchQuery = match$1[0];
  let debouncedSearchQuery = ReactUpdateDebounced.use(searchQuery, 500);
  React.useEffect(() => {
    if (mounted.current) {
      onChange(debouncedSearchQuery);
    }
  }, [debouncedSearchQuery]);
  React.useEffect(() => {
    if (mounted.current) {
      setSearchQuery(param => value);
    }
  }, [value]);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return JsxRuntime.jsx(InputSearch.make, {
    loading: false,
    onRequestClear: () => setSearchQuery(param => ""),
    focused: match[0],
    placeholder: props.placeholder,
    autoFocus: autoFocus,
    value: searchQuery,
    onChange: value => setSearchQuery(param => value),
    onFocus: () => setFocused(param => true),
    onBlur: () => setFocused(param => false)
  });
});

export {
  make,
}
/* make Not a pure module */
